<template>
  <div>
    <nav class="d-flex nav w-100">
      <div class="container d-flex justify-content-center">
        <div class="w-50 py-3 content" style="text-align:center">
          メール認証
        </div>
      </div>
    </nav>
    <div class="container d-flex py-5 main-container justify-content-center">
      <div class="w-75 thankyou-area p-0">
        <span class="thnk-image text-center">
          <img src="./../assets/images/thank-you.svg" alt="logo" class="img-fluid"/>
        </span>

        <div class="px-5 py-1 mt-4 rounded text-center">
          <p class="mt-4 font-24 letter-spacing-3">
            <strong class="text-danger">まだ会員登録は完了していません。</strong>
          </p>
          <div class="alert mb-3 mw-100 text-center" role="alert">
            <span class="email_break font-16" style="font-weight: bold;">{{ getRegEmail }} へ登録メールを送信しました</span>
          </div>
          <div>
            <p class="font-18 letter-spacing-2" style="font-weight: bold;">
              メール本文に記載されている「認証完了」をクリックして登録を完了してください
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      getRegEmail: 'getRegEmail',
      getRegCompany: 'getRegCompany',
    }),
  },
};
</script>
<style scoped>
.thankyou-area{
  width: 850px !important;
}
.custom-alert {
  color: #3d3d3d;
  background-color: #ffffff;
  border-color: #3d3d3d;
}
.custom-alert1 {
  color: rgb(15, 15, 15);
  background-color: #e9e8e8;
  border-color: #e4dede;
  font-size: 18px;
}
@media (max-width:767px) {
  .left_align {
    text-align: left !important;
  }
  .line__break{
    display: none;
  }
  .email_break{
    word-break: break-all;
  }
}
.nav{
  background-color: #006C6B;
}

.nav .content{
  font-weight: 700;
  font-size: 26px;
  line-height: 48px;
  color: white;
}

.mw-100{
  max-width: 100px;
}

.font-16{
  font-size: 16px;
}

.font-18{
  font-size: 18px;
}

.font-24{
  font-size: 24px;
}

.letter-spacing-3{
  letter-spacing: 3px;
}

.letter-spacing-2{
  letter-spacing: 2px;
}

@media only screen and (max-width: 991px) {
  .nav .content, .main-container .thankyou-area{
    width: 75% !important;
  }
}

@media only screen and (max-width: 767px) {
  .nav .content, .main-container .thankyou-area{
    width: 100% !important;
  }
}
</style>
